// extracted by mini-css-extract-plugin
export default {"topbar":"styles_topbar__0xURg"};